export default __webpack_public_path__ + "static/media/antelope-7-thumbnail.b7724cd2.webp";